import _ from 'lodash';

// Pass in an object and rename some of the keys in it
// Introduced due to ISXCSS-1080 rearrangements
export const renameObjectKeys = (obj: any, countryCode: string) => {
  if (countryCode === 'ae') {
    let newObj = _.mapKeys(obj, (value, key) => {
      switch (key) {
        case 'city':
          return 'streetAddress';
        case 'state':
          return 'city';
        default:
          return;
      }
    });
    newObj['state'] = '';
    delete newObj['undefined'];
    return newObj;
  }

  return obj;
};

// Make values more readable eg 'ABUDHABI' -> 'Abu Dhabi' for customer and delivery services
export const remapValuesToReadable = (obj: any, countryCode: string) => {
  const mapValue = CSS_CONFIG.MAPVALUES;

  if (countryCode === 'ae') {
    obj['city'] = mapValue[obj['city']];
    return obj;
  }

  if (countryCode === 'om') {
    obj['state'] = mapValue[obj['state']];
  }

  if (countryCode === 'qa') {
    obj['state'] = mapValue[obj['state']];
  }

  return obj;
};
